import './public-path';
import React,{Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './src/App';
import { ThroughProvider } from 'react-through';
import { ru } from 'date-fns/locale';
import { RuLocalizedUtils } from './src/utils/datePicker';
import './index.less';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { StoreProvider } from './src/stores/StoreHelpers';
import { MainStore as store } from './src/stores/mainStore';
import { CacheContextProvider } from "./src/providers/cache";
import {useProtos} from "./src/helpers/proto";
import LoadingFallback from "./src/components/LoadingFallback";
export async function bootstrap() {
  console.log('[priority-2030-app] react app bootstraped');
}

export async function mount(props = {}) {
  console.log('[priority-2030-app] props from main framework', props);
  const { container } = props;
  const theApp = (
    <ThroughProvider>
        <MuiPickersUtilsProvider locale={ru} utils={RuLocalizedUtils}>
          <StoreProvider store={new store()}>
            <CacheContextProvider>
              <App />
            </CacheContextProvider>
          </StoreProvider>
        </MuiPickersUtilsProvider>
    </ThroughProvider>
  );
  ReactDOM.render(
    theApp,
    container
      ? container.querySelector('#priority-2030-app')
      : document.getElementById('priority-2030-app'),
  );
  import('./dynamic.css').then(() => {
    console.log('[priority-2030-app] dynamic style load');
  });
}

export async function unmount(props) {
  const { container } = props;
  ReactDOM.unmountComponentAtNode(
    container
      ? container.querySelector('#priority-app')
      : document.getElementById('priority-2030-app'),
  );
}

if (!window.__POWERED_BY_QIANKUN__) {
  bootstrap().then(mount);
}

useProtos()
